import React, { useEffect } from 'react';
import { Box, Grid, Link, Typography} from '@mui/material';
import '../../../css/FactSheets.css';
import { Introduction } from '../Components/Introduction';
import { ContactUsBlock } from '../Components/ContactUsBlock';
import './AccreditedPOSProviders.css';
import PosProviderDialog from '../Components/PosProviderDialog/PosProviderDialog';
import { Helmet } from 'react-helmet';
import { PageTitles } from '../../../utils/PageTitles';
import ApiService from '../../../Services/apiServices';
import {AxiosResponse} from 'axios';
import { FactSheetServerErrorMessage } from '../FactSheetErrorMessage/FactSheetErrorMessage';

import POSProvidersList from './POSProvidersList';

export const AccreditedPOSProviders = () => {
    const [storageUrl, setStorageUrl] = React.useState<string>('');
    const [updatedDateDescription, setUpdatedDateDescription] = React.useState<string>('');
    const [apiError, setApiError] = React.useState<boolean>(false);

    useEffect(() => {
        fetchMetaData();
      }, []);

    // fetches the document's url to download from and the date description to display from the API
    // and then applies it to the page.  If it can't be found, an error message is displayed
    // next to the button and the error logged to the browser's console.
    const fetchMetaData = () => {
        ApiService.getFactSheetMetadata('What_Is_Product_Level_Blocking')
        .then((response : AxiosResponse) => {
            setApiError(false);
            setStorageUrl(response.data.value[0].StorageUrl);
            setUpdatedDateDescription(response.data.value[0].UpdatedDateDescription);
        })
        .catch((e) => {
            console.log('Error fetching factsheet metadata for What is product level blocking');
            console.error(e);
            setApiError(false);
            setUpdatedDateDescription(FactSheetServerErrorMessage);
        });
    };

    const heading1 = {
        start: "PLB ",
        highlight: "Accredited POS Providers",
        body: <>
                     If your business has a PLB-accredited point of sale (POS) system and a current support agreement, it is likely there is no cost to upgrade your POS system.
            </>
    }

    return(
        <>
            <Helmet>
                <title>{PageTitles.AccreditedPOSProviders} </title>
            </Helmet>
            <Introduction
                heading1 = {heading1}
                downloadButton = {false}                
                storageUrl={storageUrl}
                updatedDateDescription={updatedDateDescription}
                apiError={apiError}
            />

            <Box className="facts_background violetBackground" id="PLB-accredited">
                <Box className="facts_contentContainer" sx={{alignItems:'center'}}>
                    <Box className="plb_accreditedBox" sx={{mb:'3.125rem'}}>

                        <Typography variant="body2" className="plb_accreditedBoxBody" sx={{mb:'2.1875rem'}}>
                            Please click on the POS provider name to see their contact information.
                        </Typography>

                        {/* 
                            Flow of the data.
                             - left-to-right: 
                               - grid container: direction="row"
                               - grid item:      xs={12} md={3} 
                             - top-to-bottom:
                               - grid container: direction="column" sx={{height: '700px'}} 
                             - columnSpacing and columns applies to both.
                             - for column layout the height needs to be adjusted when the amount of data changes, grows sideways.

                        */}
                        <Grid container columnSpacing={2} columns={{xs:4, sm:8, md:12}}
                            direction="row"           
                            //direction="column" sx={{height: '700px'}}  // column
                        >

                            {Array.from(POSProvidersList)
                                .sort((a, b) => {

                                    let name1 = a.name.toLowerCase();
                                    let name2 = b.name.toLowerCase();

                                    if (name1 > name2) {
                                        return 1;
                                    }

                                    if (name1 < name2) {
                                        return -1;
                                    }

                                    return 0;
                                })
                                .map((value, _) => (

                                     <Grid item 
                                        xs={12} md={3} // row
                                     >
                                        <PosProviderDialog
                                            name={value.name}
                                            posName={value.posName}
                                            website={value.website}
                                            website2={value.website2}
                                            email={value.email}
                                            customEmail={value.customEmail}
                                            phone={value.phone}
                                            phoneAvailability={value.phoneAvailability}
                                            customContent={value.customContent}
                                            noModal={value.noModal}
                                        />
                                    </Grid>
                                ))
                            }

                        </Grid>

                    </Box>
                    <Typography variant="body2" className="plb_accreditedText">
                        If your POS provider is not currently listed as PLB-accredited, it may be joining the Product Level Blocking program soon. You can contact us to find out if your POS provider is joining the program.
                    </Typography>

                </Box>
            </Box>

            <ContactUsBlock
                variant = "white"
            />
        </>
    );

}
